
define('text!modules/audiences/onboarding/create/templates/header.html',[],function () { return '<div class="w-head onboarding-head">\n  <strand-icon type="pixels" optimize="true" width="16" height="16"></strand-icon>\n  <strand-header size="large">{{title}}</strand-header>\n</div>\n';});

